import { AudioClip, AudioProject } from '@models/Sessions/Idea/AudioProject';
import keyBy from 'lodash/keyBy';

export const mapAudioClips = (
  audioProject: AudioProject,
): Record<AudioClip['_id'], AudioClip> => {
  return keyBy(
    audioProject.segments.flatMap(({ clips }) => {
      return clips;
    }),
    '_id',
  );
};
